<template lang="pug">
	.v-small-slider.small-slider(:class="['image-slider--' + mode, {'loading': loading, 'image-slider--full': slider && slider.items && slider.items.length > 1}]")
		.small-slider__slider(v-if="slider && slider.items && slider.items.length")
			button.image-slider__gallery-btn(type="button" @click="openGallery"
				v-if="mode === 'regular' && slider.button?.open"
				:aria-label="slider.button?.open?.ariaLabel")
				v-svg-icon.image-slider__gallery-icon(:icon="slider.button.open.icon")
			.small-slider__arrow.small-slider__arrow--prev(ref="prev")
				v-svg-icon.small-slider__arrow-icon(icon="slide-left")
			.small-slider__arrow.small-slider__arrow--next(ref="next")
				v-svg-icon.small-slider__arrow-icon(icon="slide-right")
			v-swiper-slider(v-if="slider && slider.items && slider.items.length"
				:options="options"
				:navigation="navigation"
				height= 266
				@slide-change="onSlideChange"
				@swiper="onSwiper")
				template(v-for="(slide, index) in slider.items" :key="index")
					v-swiper-slide
						.small-slider__item
							template(v-if="slide.type === 'video'")
								video.small-slider__image(:src="slide.link" :alt="slide.alt")
								button.video__btn(@click="openGallery")
									v-svg-icon.video__btn-icon(icon="play-btn")
							template(v-else-if="slide.type === 'youtube'" )
								img.small-slider__image(:src="slide.src" :alt="slide.alt" loading="lazy")
								button.video__btn(@click="openGallery")
									v-svg-icon.video__btn-icon(icon="play-btn")
							template(v-else)
								a.small-slider__link(v-if="link" :href="link")
									img.small-slider__image(:src="slide.src" :alt="slide.alt" loading="lazy")
								img.small-slider__image(v-else :src="slide.src" :alt="slide.alt" loading="lazy")

		v-swiper-slider(v-if="slider && slider.items && slider.items.length"
			:options="optionsThumbs"
			:navigation="navigationThumbs"
			@swiper="onSwiperThumbs")
			template(v-for="(slide, index) in slider.items" :key="index")
				v-swiper-slide(@click="slideToIndex(index)")
					.small-slider__item-thumb
						template(v-if="slide.type === 'video'")
							video.image-slider__thumb(:src="slide.link" :alt="slide.alt")
							.video__btn
								v-svg-icon.video__btn-icon(icon="play-btn")
						template(v-else-if="slide.type === 'youtube'")
							img.image-slider__thumb(:src="slide.src" :alt="slide.alt" loading="lazy")
							.video__btn
								v-svg-icon.video__btn-icon(icon="play-btn")
						template(v-else)
							img.image-slider__thumb(:src="slide.src" :alt="slide.alt" loading="lazy")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import uniqueId from '../scripts/helpers/uniqueId';
import {SwiperSlide} from 'swiper/vue';
import breakpoints from '../scripts/breakpoints';
import controller from '../scripts/controller/controller';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';

export default {
	components: {
		'v-swiper-slide': SwiperSlide
	},

	mixins: [
		sourceMixin,
		isMobMixin
	],

	emits: [
		'open-gallery'
	],

	props: {
		mode: {
			type: String,
			default: 'regular'
		},

		title: {
			type: String,
			default: null
		},

		initialIndex: {
			type: Number,
			default: 0
		},

		link: {
			type: String,
			default: null
		}
	},

	data() {
		return {
			slider: {},
			uniqueId: uniqueId('swiper-'),
			newOptions: null,
			isMdTimeout: null,
			thumbsSwiper: null,
			mainSwiper: null,
			activeIndex: 0,
			options: {
				slidesPerView: 1,
				spaceBetween: 10,
				watchOverflow: true,
				thumbs: {
					swiper: this.thumbsSwiper
				},
				initialSlide: this.initialIndex,
				breakpoints: {
					// when window width is >= x
					[breakpoints['xl-min']]: {
						spaceBetween: 0
					},
					[breakpoints['lg-min']]: {
						spaceBetween: 0
					},
					[breakpoints['sm-min']]: {
						spaceBetween: 0
					}
				}
			},
			optionsThumbs: {
				slidesPerView: 3,
				spaceBetween: 5,
				watchOverflow: true,
				// breakpoints: {
				// 	// when window width is >= x
				// 	[breakpoints['md-min']]: {
				// 		slidesPerView: 6
				// 	},
				// 	[breakpoints['sm-min']]: {
				// 		slidesPerView: 5
				// 	},
				// 	[breakpoints['xs-min']]: {
				// 		slidesPerView: 4
				// 	},
				// 	[breakpoints['2xs-min']]: {
				// 		slidesPerView: 3
				// 	},
				// 	[breakpoints['4xs-min']]: {
				// 		slidesPerView: 2
				// 	}
				// }
			},
			navigation: false,
			navigationThumbs: false
		};
	},

	methods: {
		onSwiper(slider) {
			this.mainSwiper = slider;
			this.navigation = {
				prevEl: this.$refs['prev'],
				nextEl: this.$refs['next']
			}
		},

		onSwiperThumbs(slider) {
			this.thumbsSwiper = slider;
		},


		onSlideChange(slider) {
				this.activeIndex = slider.realIndex;
				this.thumbsSwiper.slideTo(slider.realIndex);
		},

		slideToIndex(index) {
			this.activeIndex = index;
			this.mainSwiper.slideTo(index);
		},

		openGallery() {
			this.$emit('open-gallery', this.activeIndex)
			// let dataGallery = {
			// 	items: this.slider.items
			// };
			// controller.openModal({
			// 	className: 'modal--gallery',
			// 	content: `<v-gallery :data-source='${(dataGallery ? JSON.stringify(dataGallery) : null)}' :initial-index='${this.activeIndex}'></v-gallery>`
			// });
		},


		dataSet(data) {
			this.slider = data;
			this.uniqueId = uniqueId('swiper-');
		}
	}
};
</script>